<template>
  <div class="video_local_container" :class="{ pack_local_container: isPackUp }">
    <div class="top_container">
      <span>{{ $t('aheader.本地视频') }}</span>
      <span class="close local_close" @click="closeLocalVideo">
        <img :src="require('@/svg/close.svg')" />
      </span>
    </div>
    <video v-show="videoStatus == 'active'" id="local" muted autoplay class="video_local"></video>
    <div v-if="videoStatus != 'active'" class="check-nocamera">
      <img v-show="videoStatus != 'active'" :src="require('@/svg/nocamera.svg')" />
    </div>
    <div class="video-control">
      <el-tooltip
        :content="$t('aheader.视频已开启')"
        placement="bottom-start"
        v-if="videoStatus == 'active'"
      >
        <a href="javascript:;" @click.stop="changeCamera" class="local-video">
          <img :src="require('@/svg/local_video.svg')" />
        </a>
      </el-tooltip>
      <el-tooltip
        :content="$t('aheader.视频已关闭')"
        placement="bottom-start"
        v-else-if="videoStatus == 'inactive'"
      >
        <a href="javascript:;" @click.stop="changeCamera" class="local-video">
          <img :src="require('@/svg/video_main.svg')" v-if="authVideo == 0 && avctl == 0" />
          <img :src="require('@/svg/local_video_close.svg')" v-else />
        </a>
      </el-tooltip>
      <el-tooltip
        :content="disabledContent"
        placement="bottom-start"
        v-else-if="videoStatus === 'disabled'"
      >
        <a href="javascript:;" class="local-video video-disable"
          ><img :src="require('@/svg/open_local.svg')"
        /></a>
      </el-tooltip>
      <el-tooltip :content="disabledContent" placement="bottom-start" v-else>
        <a href="javascript:;" class="local-video video-disable"
          ><img :src="require('@/svg/local_video_close2.svg')"
        /></a>
      </el-tooltip>
      <el-tooltip :content="$t('aheader.设置')" placement="bottom-start">
        <a href="javascript:;" @click.stop="setSetting" class="local-video"
          ><img :src="require('@/svg/setting.svg')"
        /></a>
      </el-tooltip>
    </div>
  </div>
</template>
<script>
import Bus from '@/components/doc/bus';
export default {
  name: 'localVideo',
  data() {
    return {
      showLocal: false,
      disabled: false
    };
  },
  computed: {
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
    isPackUp() {
      return this.$store.getters.isPackUp;
    },
    videoStatus() {
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.mediaStatus
        ? this.$store.getters.selfParticipant.mediaStatus.video
        : 'disabled';
    },
    disabledContent() {
      // 嘉宾身份，9:16模式下提示9:16视频无法开启摄像头
      if (
        this.selfType == 1 &&
        this.$store.state.liveInfo.liveConfig &&
        this.$store.state.liveInfo.liveConfig.video_source_ratio
      ) {
        return this.$t('video.videoSourceRatio');
      } else {
        return this.$t('aheader.视频已关闭');
      }
    },
    authVideo() {
      return (
        this.$store.getters.meetStatusInfo &&
        this.$store.getters.meetStatusInfo.groupInfo &&
        this.$store.getters.meetStatusInfo.groupInfo.video
      );
    },
    avctl() {
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.avctl;
    },
    publishStream() {
      let pubStream = null;
      if (
        this.rtcClient.RTCRoom.webrtc &&
        this.rtcClient.RTCRoom.webrtc.publishLocal &&
        this.rtcClient.RTCRoom.webrtc.publishLocal.publishStream
      ) {
        pubStream = this.rtcClient.RTCRoom.webrtc.publishLocal.publishStream;
      }
      return pubStream;
    },
    userInfo() {
      return this.$store.getters.userInfo;
    }
  },
  mounted() {
    Bus.$on('getLocalVideo', () => {
      this.getLocalVideo();
    });
  },
  methods: {
    closeLocalVideo() {
      this.$emit('closeLocal');
    },
    setSetting() {
      this.$store.commit('SHOW_SETTING', true);
    },
    changeCamera() {
      // 2.0.10 允许嘉宾与主播关闭音视频设备
      if (this.videoStatus == 'inactive' && this.authVideo == 0 && this.avctl == 0) {
        this.$message.error(this.$t('aheader.视频主控模式已开启，禁止打开摄像头'));
        return;
      }

      if (this.disabled) return;
      const status = this.videoStatus == 'active' ? 'inactive' : 'active';
      this.rtcClient.RTCRoom.handleParticipantCamera(
        this.userInfo.uid,
        this.userInfo.cid,
        status
      ).then(() => {
        this.$store.commit('SET_SELFVIDEOSTATUS', status);
      });
    },
    getLocalVideo() {
      let _this = this;
      if (this.publishStream) {
        var video = document.querySelector('video');
        video.srcObject = this.publishStream;
        _this.disabled = false;
      } else {
        _this.disabled = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.video_local_container {
  position: absolute;
  left: 80px;
  z-index: 600;
  bottom: 130px;
  width: 360px;
  height: 300px;
  background: #212442;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  color: #acb2bf;
}
.video_local {
  width: 330px;
  height: 186px;
}
.pack_local_container {
  right: 20px;
}
.local_close {
  position: absolute;
  top: 8px;
  right: 15px;
  margin-left: 0;
}

.video-control {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  a {
    margin: 0 8px;
  }
}

.check-nocamera {
  width: 330px;
  height: 190px;
  margin: 0;
  line-height: 186px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.video-disable {
  // background: #8a8f99;
  // cursor: default;
  // opacity: 0.4;
}
.audio-disable {
  opacity: 0.5;
  cursor: default;
}
.close {
  position: relative;
  width: 12px;
  height: 12px;
  right: 0;
  top: 0;
  margin-left: 6px;
  cursor: pointer;
}
.top_container {
  padding: 8px 0;
  height: 35px;
  line-height: 35px;
}
.local_close {
  position: absolute;
  top: 8px;
  right: 15px;
  margin-left: 0;
}

.local-video {
  width: 29px;
  height: 28px;
  line-height: 32px;
  background: rgba($color: #313459, $alpha: 1);
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
[data-theme='Orange'] .local-video {
  background-color: rgba(221, 221, 221, 0.5) !important;
}
.video-disable {
  // background: #8a8f99;
  cursor: default;
  // opacity: 0.4;
}
</style>
